export const sendToHubspot = route => {
  const _hsq = window._hsq || []
  _hsq.push(['setPath', route])
  _hsq.push(['trackPageView'])
}
